const CloseSvg = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
      <path
        d="M11.3459 4.65296C11.2472 4.55502 11.1134 4.5 10.9739 4.5C10.8343 4.5 10.7005 4.55502 10.6018 4.65296L7.99682 7.23897L5.39185 4.65296C5.2926 4.5578 5.15967 4.50514 5.02168 4.50633C4.8837 4.50752 4.75171 4.56246 4.65414 4.65932C4.55656 4.75619 4.50122 4.88722 4.50002 5.0242C4.49882 5.16117 4.55186 5.29314 4.64773 5.39167L7.62476 8.34704C7.72345 8.44498 7.85728 8.5 7.99682 8.5C8.13637 8.5 8.2702 8.44498 8.36889 8.34704L11.3459 5.39167C11.4446 5.2937 11.5 5.16084 11.5 5.02232C11.5 4.88379 11.4446 4.75093 11.3459 4.65296Z"
        fill="#D5D5D5"
      />
      <path
        d="M11.3459 11.347C11.2472 11.445 11.1134 11.5 10.9739 11.5C10.8343 11.5 10.7005 11.445 10.6018 11.347L7.99682 8.76103L5.39185 11.347C5.2926 11.4422 5.15967 11.4949 5.02168 11.4937C4.8837 11.4925 4.75171 11.4375 4.65414 11.3407C4.55656 11.2438 4.50122 11.1128 4.50002 10.9758C4.49882 10.8388 4.55186 10.7069 4.64773 10.6083L7.62476 7.65296C7.72345 7.55502 7.85728 7.5 7.99682 7.5C8.13637 7.5 8.2702 7.55502 8.36889 7.65296L11.3459 10.6083C11.4446 10.7063 11.5 10.8392 11.5 10.9777C11.5 11.1162 11.4446 11.2491 11.3459 11.347Z"
        fill="#D5D5D5"
      />
    </svg>
  );
};

export default CloseSvg;
